import { AppProps } from 'next/app';
import { appWithTranslation } from 'next-i18next';
import { theme } from 'twin.macro';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { AuthGuard } from '@restworld/feature-authentication';
import { Spinner } from '@restworld/ui-ds';

import NextNProgress from 'nextjs-progressbar';

import nextI18NextConfig from '../next-i18next.config';
import GlobalStyles from '../styles/GlobalStyles';
import '../styles/globals.css';
import ErrorBoundaryWrapper from '../components/error-boundary';
import { MainContextWrapper } from '../context';

function CustomApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  useEffect(() => {
    const handleRouteChangeStart = (url: string) => {
      // eslint-disable-next-line no-console
      console.trace('Route change trace:', url);
    };
    router.events.on('routeChangeStart', handleRouteChangeStart);
    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, [router.events]);
  return (
    <>
      <GlobalStyles />
      <ErrorBoundaryWrapper>
        <MainContextWrapper>
          <NextNProgress
            color={theme`colors.primary.500`}
            showOnShallow
            options={{
              showSpinner: false,
            }}
          />
          <AuthGuard loader={<Spinner size="lg" color="primary" />}>
            <Component {...pageProps} />
          </AuthGuard>
        </MainContextWrapper>
      </ErrorBoundaryWrapper>
    </>
  );
}

export default appWithTranslation(CustomApp, nextI18NextConfig);
